import { asset } from "../assets";

/** The existing brand symbol, never a typographic approximation. */
export function OptrixisMark({ className = "" }: { className?: string }) {
  return (
    <img
      src={asset("Favicon_OptrixisOptrixis_Mail.svg")}
      width="40"
      height="40"
      alt=""
      aria-hidden="true"
      draggable={false}
      className={`optrixis-symbol ${className}`.trim()}
    />
  );
}
